/* esm.sh - micromark-extension-gfm-footnote@2.1.0 */
export * from "/*micromark-extension-gfm-footnote@2.1.0/esnext/micromark-extension-gfm-footnote.mjs";
